<template>
  <div class="upload-file">
    <div v-if="value" class="select-file-warp">
      <p class="file-name">
        <i class="el-icon-document" style="margin-right: 4px"></i
        >{{ value.name }}
      </p>
      <i class="el-icon-error clear-btn" @click="clearFiles"></i>
    </div>
    <label v-else class="select-file-btn" :for="fileId">{{ label }}</label>
    <span class="upload-file-tips">{{ tips }}</span>

    <input
      :id="fileId"
      ref="file"
      class="hide-input"
      type="file"
      :accept="accept"
      @change="change"
    />
  </div>
</template>
<script>
export default {
  name: 'upload-file',
  props: {
    value: File,
    label: String,
    tips: String,
    limitSize: {
      type: Number,
      default: 50,
    },
    accept: String,
  },
  computed: {
    fileId() {
      return 'fileId_' + this._uid
    },
  },
  methods: {
    clearFiles() {
      this.$refs.file.value = null
      this.$emit('input', null)
    },
    change(e) {
      var files = e.target.files
      if (files.length > 0) {
        var fileData = files[0]
        if (fileData.size > this.limitSize * 1048576) {
          alert('文件超过' + this.limitSize + 'MB')
          this.$refs.file.value = null
          return
        }
        this.$emit('input', fileData)
      }
    },
  },
}
</script>
<style lang="less">
.upload-file {
  .select-file-warp {
    box-sizing: border-box;
    padding: 8px;
    color: #646464;
    background-color: #e4e4e4;
    margin-bottom: 2px;

    position: relative;
    .file-name {
      font-size: 14px;
      line-height: 20px;
      margin: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .clear-btn {
      cursor: pointer;
      font-size: 20px;
      position: absolute;
      top: -10px;
      right: -10px;
      transition: color ease-in-out 0.2s;
      &:hover {
        color: #f56c6c;
      }
    }
  }
  .select-file-btn {
    box-sizing: border-box;
    background-color: #e4e4e4;
    color: #646464;
    font-size: 14px;
    line-height: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
    display: block;
    text-align: center;
    cursor: pointer;
    margin-bottom: 2px;
  }
  .upload-file-tips {
    font-size: 12px;
    color: #929292;
  }
  .hide-input {
    display: none;
  }
}
@media (min-width: 768px) {
  .upload-file {
    .select-file-btn,
    .select-file-warp {
      font-size: 22px;
      margin-bottom: 6px;
    }
    .upload-file-tips {
      font-size: 15px;
    }
  }
}
</style>